import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';
import SectionHeading from '@/components/base/SectionHeading';

export default function CategoryShowcase() {
  return (
    <section aria-label="主题分类" className="mx-auto mt-16 w-full max-w-[1280px] px-4 md:mt-20 md:px-6">
      <SectionHeading
        eyebrow="主题分类"
        title="四个方向，追你想追的那一条线"
        desc="看料99 把内容按娱乐、社会、职场、生活四个方向整理，每条线索都能顺着时间往下读。"
      />
      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-background-100"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600">
              <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{c.name}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
              进入分类
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}